import { render, staticRenderFns } from "./extra_traderProfit.vue?vue&type=template&id=9be1af9c&"
import script from "./extra_traderProfit.vue?vue&type=script&lang=js&"
export * from "./extra_traderProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports